import { z } from 'zod'
import { gapErrorShapeSchema } from '@gap/backend/endpoints/trpc/error-handler/GapErrorTypes'
import { TRPC_ERROR_CODES_BY_KEY } from '@trpc/server/rpc'
import { invert } from '@gap/utils/utils'

export const GAP_TRPC_ERROR_CODES_BY_KEY = {
   ...TRPC_ERROR_CODES_BY_KEY,
   INTERNAL_SERVER_ERROR: -12300,
} as const

export const GAP_TRPC_ERROR_CODES_BY_NUMBER = invert(GAP_TRPC_ERROR_CODES_BY_KEY)

export interface TrpcFetcherOptions {
   silent?: boolean
   fetchParams: Parameters<typeof fetch>
   cors?: boolean
   auth?: {
      type: 'jwt'
      token: string
   }
}

export const trpcResponseErrorSchema = z.object({
   json: z.object({
      // tRPC default properties
      message: z.string(),
      code: z.nativeEnum(GAP_TRPC_ERROR_CODES_BY_KEY),
      data: z.object({
         // Our additional context
         code: z.nativeEnum(GAP_TRPC_ERROR_CODES_BY_NUMBER),
         httpStatus: z.number().optional(),
         path: z.string().optional(),
         gapError: z.object({ gapErrorData: gapErrorShapeSchema }).nullable().optional(),
         validationErrors: z
            .array(
               z.object({
                  field: z.string(),
                  message: z.string(),
               })
            )
            .optional(),
      }),
      // Optional original error, with stack redacted
      cause: z
         .object({
            name: z.string(),
            message: z.string(),
            stack: z.string().optional(),
         })
         .optional(),
   }),
})

export type CustomTrpcError = z.output<typeof trpcResponseErrorSchema>

export const trpcResponseSchema = z.array(
   z.object({
      error: trpcResponseErrorSchema.optional(),
      result: z
         .object({
            data: z.any(),
         })
         .optional(),
   })
)

export type TrpcResponse = z.output<typeof trpcResponseSchema>
